import React from "react";
// eslint-disable-next-line
import {
    alpha,
    Box,
    Button,
    Card,
    CardContent,
    CardHeader,
    Divider,
    Drawer,
    Grid,
    IconButton,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Close } from "@material-ui/icons";
import { InfoOutlined } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const BORDERED_LAYOUT = process.env.REACT_APP_BORDERED_LAYOUT
    ? JSON.parse(process.env.REACT_APP_BORDERED_LAYOUT)
    : false;

const useStyles = makeStyles((theme) => ({
    fullList: {
        width: "auto",
    },
    drawerPaper: {
        width: "37vw",
        minWidth: 300,
        maxWidth: "100vw",
        padding: theme.spacing(4),
    },
    AccordionRoot: {
        // border: `1px solid ${alpha(theme.palette.primary.main, 0.125)}`,
        border: "none",

        boxShadow: "none",
        "&:not(:last-child)": {
            borderBottom: 0,
        },
        "&:before": {
            display: "none",
        },
        "&$expanded": {
            margin: "auto",
        },
    },
    expanded: {},
    AccordionSummaryRoot: {
        backgroundColor: alpha(theme.palette.primary.main, 0.0675),
        // borderBottom: `1px solid ${alpha(theme.palette.primary.main, 0.125)}`,
        borderBottom: "none",
        marginBottom: -1,
        minHeight: "32px!important",
        "&$expanded": {
            minHeight: 32,
        },
    },
    AccordionSummaryContent: {
        margin: `${theme.spacing(1, 0)}!important`,
    },
    AccordionSummaryContentExpanded: {
        margin: theme.spacing(0, 0),
    },
    AccordionSummaryTitle: {
        fontSize: "clamp(12px, 1vw, 1rem)",
        fontWeight: theme.typography.fontWeightMedium,
    },
    AccordionDetailsRoot: {
        padding: theme.spacing(2),
    },
    card: {
        height: "100%",
    },
    cardHeaderRoot: {
        backgroundColor: alpha(theme.palette.primary.main, 0.00675),
        padding: theme.spacing(1, 1, 0, 2),
    },
    cardContent: {
        padding: theme.spacing(0, 1, 2, 2),
    },
    cardHeaderTitle: {
        // fontSize: '0.8rem',
        fontSize: "clamp(12px, 1vw, 1rem)",
        // fontWeight: theme.typography.fontWeightMedium,
        fontWeight: 400,
    },
    infoLetter: {
        width: 22,
        height: 22,
        backgroundColor: "#fff",
        borderRadius: "50%",
        fontSize: "0.875rem",
        fontWeight: theme.typography.fontWeightBold,
        lineHeight: "22px",
    },
    // AccordionSummaryContent: {
    //     margin: `${theme.spacing(1, 0)}!important`,
    // },
    // AccordionSummaryContentExpanded: {
    //     margin: theme.spacing(0, 0),
    // },

    AccordionSummaryExpandIcon: {
        transform: "rotate(0deg)!important",
        marginRight: "0!important",
    },
    // AccordionDetailsRoot: {
    //     padding: theme.spacing(2),
    // },

    headerWrap: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: theme.spacing(0, 1),
        marginBottom: theme.spacing(5),
        width: "100%",

        // position: "relative",
        position: "sticky",
        top: -1,
        backgroundColor: "#FFF",
        paddingTop: theme.spacing(2),

        [theme.breakpoints.down("lg")]: {
            padding: theme.spacing(1, 0, 0, 0),
            marginBottom: theme.spacing(2),
            alignItems: "flex-start",
        },
    },
    mainTitleWrap: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        flexGrow: 1,
        paddingLeft: theme.spacing(1),
        [theme.breakpoints.down("lg")]: {
            alignItems: "flex-start",
        },
    },
    mainTitle: {
        // fontSize: "1.3333333rem",
        fontSize: "clamp(14px, 2vw, 1.25rem)",
        fontWeight: 600,
        [theme.breakpoints.down("lg")]: {
            // fontSize: "1.11111111rem",
        },
        [theme.breakpoints.down("md")]: {
            // fontSize: "0.88888889rem",
        },
    },
}));

const ObjectsDrawer = ({ id_obiektu, cechyobiektu }) => {
    const classes = useStyles();
    const { t } = useTranslation();

    const [state, setState] = React.useState(false);

    const toggleDrawer = (open) => (event) => {
        if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
            return;
        }

        setState(open);
    };

    return (
        <>
            <div style={{ textAlign: "center", padding: "8px 8px", marginTop: 16 }}>
                <Button
                    variant={"outlined"}
                    color={"primary"}
                    onClick={toggleDrawer(true)}
                    startIcon={BORDERED_LAYOUT ? <InfoOutlined /> : undefined}
                    endIcon={BORDERED_LAYOUT ? undefined : <InfoOutlined style={{ marginLeft: 16 }} />}
                    fullWidth
                    disableRipple={!BORDERED_LAYOUT}
                    style={{
                        fontSize: BORDERED_LAYOUT ? undefined : "1rem",
                        letterSpacing: BORDERED_LAYOUT ? undefined : "0.17136px",
                        textTransform: BORDERED_LAYOUT ? undefined : "initial",
                        fontWeight: BORDERED_LAYOUT ? undefined : 600,
                        borderRadius: BORDERED_LAYOUT ? 18 : 0,
                        backgroundColor: "#00000005",
                        borderColor: BORDERED_LAYOUT ? undefined : "transparent",
                        justifyContent: BORDERED_LAYOUT ? "center" : "flex-end",
                        color: BORDERED_LAYOUT ? undefined : "inherit",
                        paddingRight: BORDERED_LAYOUT ? undefined : 24,
                    }}
                >
                    {t("obiekt.cechy")}
                </Button>
            </div>

            <Drawer
                anchor={"right"}
                open={state}
                onClose={toggleDrawer(false)}
                classes={{ paper: classes.drawerPaper }}
            >
                {/* <pre>{JSON.stringify(cechyobiektu, null,4)}</pre> */}
                <Grid container spacing={1} alignItems={"center"} style={{ marginBottom: 8 }}>
                    <Grid item xs>
                        <Box className={classes.headerWrap}>
                            <Box className={classes.mainTitleWrap}>
                                <InfoOutlined sx={{ mr: 1 }} fontSize="small" />
                                <Typography variant={"body1"} component={"span"} className={classes.mainTitle}>
                                    {t("obiekt.cechy")}
                                </Typography>
                            </Box>

                            <Box sx={{ flexWrap: "nowrap", display: "flex" }}>
                                {/* <AppTooltip title={t("Zamknij okno")} arrow placement={"top-end"} type={"dark"}> */}
                                <IconButton onClick={toggleDrawer(false)} aria-label={t("Zamknij okno")}>
                                    <Close color={"primary"} fontSize="small" />
                                </IconButton>
                                {/* </AppTooltip> */}
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
                <Grid container spacing={1}>
                    {cechyobiektu.map((feature) => {
                        // feature.aktyprawne.length && console.log(feature)
                        return (
                            <Grid item xs={12} md={12} key={feature.id_cechy}>
                                <Card variant="elevation" className={classes.card} elevation={0}>
                                    <CardHeader
                                        classes={{ root: classes.cardHeaderRoot, title: classes.cardHeaderTitle }}
                                        title={feature.nazwa_cechy}
                                    />
                                    <CardContent className={classes.cardContent}>
                                        {/* <code style={{ fontStyle: "italic" }}>{feature.definicja_cechy || t('obiekt.no_feature_description')}</code> */}
                                        <code style={{ fontStyle: "italic", fontFamily: "Fira Sans, sans-serif" }}>
                                            {feature.definicja_cechy || ""}
                                        </code>
                                    </CardContent>
                                    <Divider />
                                </Card>
                            </Grid>
                        );
                    })}
                </Grid>
            </Drawer>
        </>
    );
};

export default ObjectsDrawer;
